import { useState, useEffect, useContext, useRef } from 'react';

import { cmnContext } from '../../../../../common/CmnContext';
import { PracticeReseveContext } from '../../../PracticeReseveContext';


// 講師選択
function PracticeReserveSelectInstructorSelect(props: any) {
  const { isPc } = useContext(cmnContext);
  const { kidPracticeInstIds } = useContext(PracticeReseveContext);

  const setIsDispModal = props.setIsDispModal;
  const selectInst = props.selectInst;
  const jaRandomInstructor = props.jaRandomInstructor;
  // 講師未選択画像
  const noSelectImg = props.noSelectImg;
  // 講師情報から画像取得
  const getInstImg = props.getInstImg;
  // 講師情報(日本語可/出身地)
  const getInstInfo = props.getInstInfo;

  const wrapDivRef = useRef<HTMLDivElement | null>(null);

  // 講師画像
  const [imgSize, setImgSize] = useState<string>('0px');
  const [selectImgSrc, setSelectImgSrc] = useState<string>(noSelectImg);
  const [instInfo, setInstInfo] = useState<string>('');


  // 講師画像サイズ
  useEffect(() => {
    if (wrapDivRef.current) {
      const wrapWidth = wrapDivRef.current.offsetWidth;
      setImgSize(isPc
        ? (wrapWidth * 0.17) + 'px'
        : (wrapWidth * 0.25) + 'px'
      );
    }
  }, [wrapDivRef]);


  // 選択講師情報
  useEffect(() => {
    if(selectInst) {
      // 画像
      const newSelectImgSrc = getInstImg(selectInst);
      setSelectImgSrc(newSelectImgSrc);
      // 講師情報: 日本語可/出身地
      const newInstInfo = getInstInfo(selectInst);
      setInstInfo(newInstInfo);

    } else {
      // 講師未選択
      setSelectImgSrc(noSelectImg);
    }
  }, [selectInst])


  
  return (
    <div
      ref={wrapDivRef}
      style={{
        display: 'flex',
        textAlign: 'left',
        alignItems: 'center',
      }}
    >

      {/* 画像 */}
      <img
        className="img-rounded img-responsive"
        style={{
          width: imgSize,
          height: imgSize,
          objectFit: 'cover',
          marginRight: '5px',
        }}
        src={selectImgSrc}
      />

      {/* 情報 */}
      <div style={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        padding: '0 2% 0',
      }}>
        <div>
          {selectInst ?
            <>
              <div style={{ display: 'flex', alignItems: 'center', gap: '3px' }}>
                <p style={{margin: 0}}>{selectInst.name}</p>
              </div>
              {selectInst.inst_id != jaRandomInstructor.inst_id &&
                <>
                  {/* 初心者向け */}
                  {selectInst.is_beginner=='1' &&
                    <p className='label label-warning' style={{margin: '0 5px 0 0', fontSize: '11px', fontWeight: 'bold'}}>初心者向け</p>
                  }
                  {/* キッズプラクティス */}
                  {kidPracticeInstIds.includes(selectInst.inst_id) &&
                    <p className='label label-success' style={{margin: 0, fontSize: '11px', fontWeight: 'bold'}}>キッズ対応</p>
                  }
                  {/* 日本語可/出身地 */}
                  {instInfo &&
                    <p style={{margin: 0, fontSize: isPc? '14px' : '12px'}}>{instInfo}</p>
                  }
                  {/* 趣味 */}
                  {selectInst.hobby &&
                    <p style={{
                      margin: 0,
                      fontSize: '12px',
                      display: '-webkit-box',
                      WebkitLineClamp: 1, // 1行まで
                      WebkitBoxOrient: 'vertical',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                    }}>趣味: {selectInst.hobby}</p>
                  }
                </>
              }
            </>
          :
            <p style={{margin: 0}}>外国人講師(ランダム)</p>
          }
        </div>

        {/* 選択ボタン */}
        <div>
          <button
            type="button"
            className='btn btn-primary'
            style={{
              width: '100%',
              margin: isPc? '10px 0 0' : '5px 0 0',
              padding: isPc? '10px 15px' : '5px 10px',
            }}
            onClick={() => setIsDispModal(true)}
          >
            {(selectInst && selectInst.inst_id!=jaRandomInstructor.inst_id)? '選び直す' : '講師を選ぶ' }
          </button>
        </div>

      </div>

    </div>
  );
}
  
export default PracticeReserveSelectInstructorSelect;